/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  DiscoverProtectedResourceMetadataRequestBody,
  DiscoverProtectedResourceMetadataRequestBody$Outbound,
  DiscoverProtectedResourceMetadataRequestBody$outboundSchema,
} from "../components/discoverprotectedresourcemetadatarequestbody.js";

export type DiscoverRemoteMcpProtectedResourceMetadataSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DiscoverRemoteMcpProtectedResourceMetadataSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DiscoverRemoteMcpProtectedResourceMetadataSecurity = {
  option1?:
    | DiscoverRemoteMcpProtectedResourceMetadataSecurityOption1
    | undefined;
  option2?:
    | DiscoverRemoteMcpProtectedResourceMetadataSecurityOption2
    | undefined;
};

export type DiscoverRemoteMcpProtectedResourceMetadataRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  discoverProtectedResourceMetadataRequestBody:
    DiscoverProtectedResourceMetadataRequestBody;
};

/** @internal */
export type DiscoverRemoteMcpProtectedResourceMetadataSecurityOption1$Outbound =
  {
    "project_slug_header_Gram-Project": string;
    "session_header_Gram-Session": string;
  };

/** @internal */
export const DiscoverRemoteMcpProtectedResourceMetadataSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DiscoverRemoteMcpProtectedResourceMetadataSecurityOption1$Outbound,
    DiscoverRemoteMcpProtectedResourceMetadataSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function discoverRemoteMcpProtectedResourceMetadataSecurityOption1ToJSON(
  discoverRemoteMcpProtectedResourceMetadataSecurityOption1:
    DiscoverRemoteMcpProtectedResourceMetadataSecurityOption1,
): string {
  return JSON.stringify(
    DiscoverRemoteMcpProtectedResourceMetadataSecurityOption1$outboundSchema
      .parse(discoverRemoteMcpProtectedResourceMetadataSecurityOption1),
  );
}

/** @internal */
export type DiscoverRemoteMcpProtectedResourceMetadataSecurityOption2$Outbound =
  {
    "apikey_header_Gram-Key": string;
    "project_slug_header_Gram-Project": string;
  };

/** @internal */
export const DiscoverRemoteMcpProtectedResourceMetadataSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DiscoverRemoteMcpProtectedResourceMetadataSecurityOption2$Outbound,
    DiscoverRemoteMcpProtectedResourceMetadataSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function discoverRemoteMcpProtectedResourceMetadataSecurityOption2ToJSON(
  discoverRemoteMcpProtectedResourceMetadataSecurityOption2:
    DiscoverRemoteMcpProtectedResourceMetadataSecurityOption2,
): string {
  return JSON.stringify(
    DiscoverRemoteMcpProtectedResourceMetadataSecurityOption2$outboundSchema
      .parse(discoverRemoteMcpProtectedResourceMetadataSecurityOption2),
  );
}

/** @internal */
export type DiscoverRemoteMcpProtectedResourceMetadataSecurity$Outbound = {
  Option1?:
    | DiscoverRemoteMcpProtectedResourceMetadataSecurityOption1$Outbound
    | undefined;
  Option2?:
    | DiscoverRemoteMcpProtectedResourceMetadataSecurityOption2$Outbound
    | undefined;
};

/** @internal */
export const DiscoverRemoteMcpProtectedResourceMetadataSecurity$outboundSchema:
  z.ZodMiniType<
    DiscoverRemoteMcpProtectedResourceMetadataSecurity$Outbound,
    DiscoverRemoteMcpProtectedResourceMetadataSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        DiscoverRemoteMcpProtectedResourceMetadataSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        DiscoverRemoteMcpProtectedResourceMetadataSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function discoverRemoteMcpProtectedResourceMetadataSecurityToJSON(
  discoverRemoteMcpProtectedResourceMetadataSecurity:
    DiscoverRemoteMcpProtectedResourceMetadataSecurity,
): string {
  return JSON.stringify(
    DiscoverRemoteMcpProtectedResourceMetadataSecurity$outboundSchema.parse(
      discoverRemoteMcpProtectedResourceMetadataSecurity,
    ),
  );
}

/** @internal */
export type DiscoverRemoteMcpProtectedResourceMetadataRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  DiscoverProtectedResourceMetadataRequestBody:
    DiscoverProtectedResourceMetadataRequestBody$Outbound;
};

/** @internal */
export const DiscoverRemoteMcpProtectedResourceMetadataRequest$outboundSchema:
  z.ZodMiniType<
    DiscoverRemoteMcpProtectedResourceMetadataRequest$Outbound,
    DiscoverRemoteMcpProtectedResourceMetadataRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      discoverProtectedResourceMetadataRequestBody:
        DiscoverProtectedResourceMetadataRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        gramProject: "Gram-Project",
        discoverProtectedResourceMetadataRequestBody:
          "DiscoverProtectedResourceMetadataRequestBody",
      });
    }),
  );

export function discoverRemoteMcpProtectedResourceMetadataRequestToJSON(
  discoverRemoteMcpProtectedResourceMetadataRequest:
    DiscoverRemoteMcpProtectedResourceMetadataRequest,
): string {
  return JSON.stringify(
    DiscoverRemoteMcpProtectedResourceMetadataRequest$outboundSchema.parse(
      discoverRemoteMcpProtectedResourceMetadataRequest,
    ),
  );
}
